// extracted by mini-css-extract-plugin
module.exports = {"container":"e_HA","question":"e_IA","button":"e_JA","buttonNegative":"e_KA","buttonPositive":"e_LA","icon":"e_MA","iconNegative":"e_NA","iconPositive":"e_OA"};